const updateJobCard = (jobId, jobData) => {
	// Get the job card element by its id
	const jobCard = $(`#job${jobId}`);

	// Update the status text and class
	// For example, assume jobData.job_status is "Paused" or "In Progress", etc.
	const newStatus = jobData.job_status; // e.g., "Paused"
	const newStatusSlug = newStatus.toLowerCase().replace(/\s+/g, '-'); // A simple slugify

	// Update the status container class and inner text
	jobCard.find('.job-card__status')
		.attr('class', `job-card__status job-card__status--${newStatusSlug}`);
	jobCard.find('.job-card__status span.status')
		.attr('class', `status status--${newStatusSlug}`)
		.text(newStatus);

	// Update the action buttons: if the job is paused, show "Resume" button and hide "Pause" button.
	if (jobData.is_paused) {
		jobCard.find('.job-card__actions a.pause').hide();
		jobCard.find('.job-card__actions a.resume').show();
	} else {
		jobCard.find('.job-card__actions a.pause').show();
		jobCard.find('.job-card__actions a.resume').hide();
	}
};

export default updateJobCard;